import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import SalesTypeItemVariantList from './SalesTypeItemVariantList';

class SalesTypeItemVariantsFieldArray extends React.Component {
  render() {
    const { itemForm, input } = this.props;
    const salesType = itemForm.sales_type.filter(sales => sales.selected);

    return (
      <div>
        {salesType.map((salesType, index) => {
          return (
            <div className={`row form-group`} key={salesType.id}>
              <div className="form-group col-sm-12">
                <span className={`pull-left`}>
                  <strong>{salesType.name}</strong>
                </span>
              </div>
              <SalesTypeItemVariantList
                key={index}
                index={index}
                name={input.name}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    moka: { user },
  } = state;
  const {
    item: { outlets },
  } = state.library;
  return {
    itemForm: getFormValues('itemHub')(state),
    search: getFormValues('search')(state),
    user,
    outlets,
  };
}

export default connect(mapStateToProps)(SalesTypeItemVariantsFieldArray);
